import { render } from "./chartComponentEmission.vue?vue&type=template&id=6ed379de&scoped=true"
import script from "./chartComponentEmission.vue?vue&type=script&lang=js"
export * from "./chartComponentEmission.vue?vue&type=script&lang=js"

import "./chartComponentEmission.vue?vue&type=style&index=0&id=6ed379de&scoped=true&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed379de"]])

export default __exports__